import React, { useEffect } from 'react'
import homedashboard from "../../../../assets/images/homedashboard.svg";
import dashboardmenu from "../../../../assets/images/dashboardmenu.svg";
import articleexpertdashboard from "../../../../assets/images/articleexpertdashboard.svg";
import mypaymentdashboard from "../../../../assets/images/intarestdashboard.svg"
import asktheexpertdashboard from "../../../../assets/images/asktheexpertdashboard.svg";
import articledashboard from "../../../../assets/images/articledashboard.svg";
import usermanualdashboard from "../../../../assets/images/usermanualdashboard.svg";
import accountsettingdashboard from "../../../../assets/images/accountsettingdashboard.svg";
import logoutdashboard from "../../../../assets/images/logoutdashboard.svg";
import { Link } from "react-router-dom";
import { NEW_URL, baseURL } from '../../../../constants/applicationConstants';
import swal from "sweetalert";

import { useHistory } from "react-router-dom";
import axios from 'axios'
import { useTranslation } from "react-i18next";

const SideBarsJsx = (props) => {

  const { t } = useTranslation();
  const history = useHistory();

  const {
    response
  } = props;

  useEffect(() => {
    const callDetails = () => {
      let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))
      let expertID = localStorage.getItem("masterID") && JSON.parse(localStorage.getItem("masterID"))
      const adminLoginData = localStorage.getItem('adminLoginData');

      // Create cache key
      const cacheKey = `expertDetails_`;
      
      // Check if data exists in localStorage
      const cachedData = localStorage.getItem(cacheKey);
      
      if (cachedData) {
        // Use cached data
        try {
          const parsedData = JSON.parse(cachedData);
          
          if (!adminLoginData && !parsedData?.data?.isPermanentPasswordSet) {
            history.push("/saveNewPassword");
          }
        } catch (error) {
          // If parsing fails, remove corrupted cache and make API call
          localStorage.removeItem(cacheKey);
          makeAPICall();
        }
      } else {
        // Make API call only if no cached data exists
        makeAPICall();
      }

      function makeAPICall() {
        axios.get(`${baseURL}/expert/${expertID}/details`, {
          headers: { 'x-access-token': token }
        }).then(res => {
          // Store the response data in localStorage
          if (res.data) {
            localStorage.setItem(cacheKey, JSON.stringify(res.data));
          }

          if (!adminLoginData && !res.data?.data?.isPermanentPasswordSet) {
            history.push("/saveNewPassword");
          }

        }).catch(err => {
          console.error('API call failed:', err);
          // Remove invalid cache on error
          localStorage.removeItem(cacheKey);
        })
      }
    }
    callDetails()
  }, [history]);

const alertMessage=()=>{
  swal({
    title: "Error",
    text: "Please connect with customer support to change/update your plan !",
    icon: "error",
});
}

  const logout = () => {
    swal({
      title: "Are you sure you want to Logout ?",
      icon: "warning",
      content: {
        element: "img",
        attributes: {
          src: logoutdashboard,
          alt: "Custom image",
          width: "100",
          height: "100"
        }
      },
      buttons: [
        'Continue',
        'Logout'
      ],
      dangerMode: true,
    }).then(function (isConfirm) {
      if (isConfirm) {
        localStorage.removeItem("token");
        localStorage.removeItem("loginAs");
        localStorage.removeItem("auth");
        localStorage.removeItem("masterID");
        localStorage.removeItem("expertId");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("loginData");
        localStorage.removeItem("expertData");
        localStorage.removeItem("customerId");

        localStorage.removeItem("planName");
        localStorage.removeItem("legalName");
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("description");
        localStorage.removeItem("flowName");
        localStorage.removeItem("flowType");
        localStorage.removeItem("subscriptionPlanId");
        localStorage.removeItem("planTypeID");
        localStorage.removeItem("planData");
        localStorage.removeItem("flowName");
        localStorage.removeItem("flowType");
        localStorage.removeItem("verificationStatus");
        localStorage.removeItem('VerifyInstituteID');
        localStorage.removeItem('AdminFlow');
        localStorage.removeItem('VerifyExpertID');
        localStorage.removeItem("comingFrom");

        // Clear cached expert details
        const cacheKey = `expertDetails_`;
        localStorage.removeItem(cacheKey);

        history.push("/");
        window.location.reload()
      } else {
        //   swal("Cancelled", "Your imaginary file is safe :)", "error");
      }
    })

  }
  // {t("PRINT.TITLE")}
  return (
    <>
      <div className="dashboard-container maincustomerdashboard">
        <div className="dashboardleftpanel">

          <div className="text-column">
            <div className="d-none d-sm-block">
            <div className="userdetails">
              <div className="dashboardlogo"><img src={!response?.imageUrl
                ? `https://ui-avatars.com/api/?name=${response?.firstName}+${response?.lastName}&rounded=true`
                : `${NEW_URL}/${response?.imageUrl}`} alt={`${response?.firstName} ${response?.lastName}`}></img></div>
              <div className="responsename">{`${response?.firstName} ${response?.lastName}`} <Link to={`/expertPpv/${response?.slugUrl}`} target="_blank" rel="noreferrer" className="viewprofilebtn">{t("COMMON.VIEWPROFILE")}</Link></div>
            </div>
        </div>
            <div className="dashboardlink dashboardtext mydash d-none d-sm-block">
              <ul className="dashboardinner">
                <li>
                  <Link to={'/expertDashboardHome'}>
                    <span className="menusideimage"><img src={homedashboard} alt={'icon'} /></span>
                    <p className={`${window.location.href?.toLowerCase().includes('expertdashboardhome') ? 'active' : ""}`}>{t("expertDashboard.Home")}</p>
                  </Link>
                </li>
                <li><Link to={'/expertQna'}>
                  <span className="menusideimage"><img src={asktheexpertdashboard} alt={'icon'} /></span>
                  <p className={`${window.location.href?.toLowerCase().includes('expertqna') || window.location.href?.toLowerCase().includes('expertanswer') ? 'active' : ""}`}>{t("expertDashboard.QNA")}</p></Link></li>

                <li><Link to={'/expertBlog'}>
                  <span className="menusideimage"><img src={articleexpertdashboard} alt={'icon'} /></span>
                  <p className={`${window.location.href?.toLowerCase().includes('expertblog') ? 'active' : ""}`}>{t("expertDashboard.ARTICLES_HEADING")}</p></Link></li>
                <li><Link to={'/myAds'}>
                  <span className="menusideimage"><img src={articledashboard} alt={'icon'} /></span>
                  <p className={`${window.location.href?.toLowerCase().includes('myads') ? 'active' : ""}`}>{t("instituteAds.TITLE")}</p></Link></li>
                <li><Link to={'/expertAccounts'}>
                  <span className="menusideimage"><img src={accountsettingdashboard} alt={'icon'} /></span>
                  <p className={`${window.location.href?.toLowerCase().includes('expertaccounts') ? 'active' : ""}`}>{t("expertDashboard.MyAccount")}</p></Link></li>
                {response?.instituteId ? <li  onClick={alertMessage}><Link to={'#'}>
                  <span className="menusideimage"><img src={mypaymentdashboard} alt={'icon'} /></span>
                  <p className={`${window.location.href?.toLowerCase().includes('expertpayment') ? 'active' : ""}`}>{t("expertDashboard.MY_PAYMENTS_HEADING")}</p></Link>
                </li> : <li><Link to={'/expertPayment'}>
                  <span className="menusideimage"><img src={mypaymentdashboard} alt={'icon'} /></span>
                  <p className={`${window.location.href?.toLowerCase().includes('expertpayment') ? 'active' : ""}`}>{t("expertDashboard.MY_PAYMENTS_HEADING")}</p></Link>
                </li>}
                <li><a href={'/Expertsusermanual.pdf'} target="_blank" rel="noreferrer"><span className="menusideimage"><img src={usermanualdashboard} alt={'icon'} /></span><p>{t("expertDashboard.user_manual")}</p></a></li>
                <li onClick={logout}><div className="sidebarlogout"><span className="menusideimage"><img src={logoutdashboard} alt={'icon'} /></span><p>Logout</p></div></li>
              </ul>
            </div>
            <div className="d-block d-lg-none d-sm-none d-md-none">
              <div className="dashboardlinkpop">
                <nav className="navbar">
                  <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"><img src={dashboardmenu} alt="menuicon" /></span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarText">
                    <ul className="navbar-nav dashboardinner">
                      <li className="nav-item">
                        <Link to={'/expertDashboardHome'} className={`${window.location.href?.toLowerCase().includes('expertdashboardhome') ? 'active' : ""}`}>

                          <p className={`${window.location.href?.toLowerCase().includes('expertdashboardhome') ? 'activetext' : ""}`}> <span className="menusideimage"><img src={homedashboard} alt={'icon'} /></span> {t("expertDashboard.Home")}</p>
                        </Link>
                      </li>
                      <li className="nav-item"><Link to={'/expertQna'} className={`${window.location.href?.toLowerCase().includes('expertqna') || window.location.href?.toLowerCase().includes('expertanswer') ? 'active' : ""}`}>

                        <p className={`${window.location.href?.toLowerCase().includes('expertqna') || window.location.href?.toLowerCase().includes('expertanswer') ? 'activetext' : ""}`}><span className="menusideimage"><img src={asktheexpertdashboard} alt={'icon'} /></span> {t("expertDashboard.QNA")}</p></Link></li>

                      <li className="nav-item"><Link to={'/expertBlog'} className={`${window.location.href?.toLowerCase().includes('expertblog') ? 'active' : ""}`}>

                        <p className={`${window.location.href?.toLowerCase().includes('expertblog') ? 'activetext' : ""}`}><span className="menusideimage"><img src={articleexpertdashboard} alt={'icon'} /></span> {t("expertDashboard.ARTICLES_HEADING")}</p></Link></li>
                      <li className="nav-item"><Link to={'/myAds'} className={`${window.location.href?.toLowerCase().includes('myads') ? 'active' : ""}`}>

                        <p className={`${window.location.href?.toLowerCase().includes('myads') ? 'activetext' : ""}`}> <span className="menusideimage"><img src={articledashboard} alt={'icon'} /></span>{t("instituteAds.TITLE")}</p></Link></li>
                      <li className="nav-item"><Link to={'/expertAccounts'} className={`${window.location.href?.toLowerCase().includes('expertaccounts') ? 'active' : ""}`}>

                        <p className={`${window.location.href?.toLowerCase().includes('expertaccounts') ? 'activetext' : ""}`}><span className="menusideimage"><img src={accountsettingdashboard} alt={'icon'} /></span>{t("expertDashboard.MyAccount")}</p></Link></li>
                      <li className="nav-item"><Link to={'/expertPayment'} className={`${window.location.href?.toLowerCase().includes('expertpayment') ? 'active' : ""}`}>

                        <p className={`${window.location.href?.toLowerCase().includes('expertpayment') ? 'activetext' : ""}`}><span className="menusideimage"><img src={mypaymentdashboard} alt={'icon'} /></span>{t("expertDashboard.MY_PAYMENTS_HEADING")}</p></Link></li>
                      <li className="nav-item"><a href={'/Expertsusermanual.pdf'} target="_blank" rel="noreferrer"><p><span className="menusideimage"><img src={usermanualdashboard} alt={'icon'} /></span>{t("expertDashboard.user_manual")}</p></a></li>
                      <li className="nav-item" onClick={logout}><div className="sidebarlogout"><p><span className="menusideimage"><img src={logoutdashboard} alt={'icon'} /></span>Logout</p></div></li>
                    <li>
                    <div className="userdetails">
              <div className="dashboardlogo"><img src={!response?.imageUrl
                ? `https://ui-avatars.com/api/?name=${response?.firstName}+${response?.lastName}&rounded=true`
                : `${NEW_URL}/${response?.imageUrl}`} alt={`${response?.firstName} ${response?.lastName}`}></img></div>
              <div className="responsename">{`${response?.firstName} ${response?.lastName}`} <Link to={`/expertPpv/${response?.slugUrl}`} target="_blank" rel="noreferrer" className="viewprofilebtn">{t("COMMON.VIEWPROFILE")}</Link></div>
            </div>
                    </li>
                    </ul>
                  </div>
                </nav>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default SideBarsJsx;